<script lang="ts" setup>
import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';
import dayjs from 'dayjs';
import { computed, inject } from 'vue';

import { ShippingOffer } from '@/api/shippingCalculator';
import RadioGroupItem from '@/components/base/form/RadioGroupItem.vue';
import money from '@/filters/money';
import { calculateDaysBetweenDates, DateString } from '@/utils/dateTime';

const props = defineProps<{ shippingOffer: ShippingOffer }>();

const isAdmin = inject('isAdmin', false);

const calculateArrivalDay = computed(() => {
  const { latestArrivalOn } = props.shippingOffer;
  let arrivalDay;
  const arrivalDate = dayjs(latestArrivalOn, 'YYYY-MM-DD');
  const todaysDate = dayjs().format('YYYY-MM-DD') as DateString;
  const daysfromArrival = calculateDaysBetweenDates(todaysDate, latestArrivalOn);

  switch (daysfromArrival) {
    case 0:
      arrivalDay = 'Today';
      break;
    case 1:
      arrivalDay = 'Tomorrow';
      break;
    default:
      arrivalDay = arrivalDate.format('dddd');
      break;
  }
  return `${arrivalDay}, ${arrivalDate.format('MMM D')}`;
});
</script>

<template>
  <div aria-label="Delivery Offer Radio Options" data-test="delivery-offer-list" role="radiogroup">
    <RadioGroupItem
      :modelValue="true"
      appearanceNone
      class="m-0 mt-3 md:mt-5"
      data-test="delivery-offer-radio-input"
      name="requested-delivery-offer"
      :value="true"
    >
      <div
        class="flex items-center justify-between w-full text-sm font-normal leading-4 md:leading-5 md:text-base font-proxima-nova"
      >
        <div>
          <div class="font-bold">Arrives {{ calculateArrivalDay }}</div>
          <div class="text-xs leading-4">
            {{ shippingOffer.name }}
          </div>
          <div v-if="isAdmin" class="text-nuts-red-800">
            <div>
              {{ shippingOffer.shipmentPickup.carrierCode }}
            </div>
            <div class="text-xs">
              {{ shippingOffer.shipmentPickup.carrierPickup }}
            </div>
          </div>
        </div>
        <div class="font-bold">
          {{ dollars(shippingOffer.price) > 0 ? money(shippingOffer.price) : 'FREE' }}
        </div>
      </div>
    </RadioGroupItem>
  </div>
</template>
